<template>
  <div>
    <div class="banner_box">
      <joinpartbanner></joinpartbanner>
    </div>
    <div class="detail_box">
      <div class="join_detail">
        <div class="join_title">
          {{$t('join.modeler')}}
        </div>
        <div class="company_name">
          {{$t("join.companyname")}}
        </div>
        <div class="work_property">
          <span class="work_property1">{{$t("join.worknature")}}<span class="work_property2">{{$t("join.fulltime")}}</span></span>
          <span class="work_property1">{{$t("join.salary")}}<span class="work_property2">{{$t("join.modelermoney")}}</span></span>
          <span class="work_property1">{{$t("join.education")}}<span class="work_property2">{{$t("join.specialist")}}</span></span>
          <span class="work_property1">{{$t("join.workyears")}}<span class="work_property2">{{$t("join.oneyears")}}</span></span>
        </div>
        <div class="job_content">
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positiondescribe")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>精通3DMax 精模、简模制作，熟练使用PS、AutoCAD等软件</p>
                </li>
                <li>
                  <p>熟悉3D场景制作流程及规范，精通3D场景模型以及材质贴图的制作，能熟练并独立完成效果图的渲染以及后期贴图；对效果图空间感、材料质感、灯光渲染等有较强的表现能力</p>
                </li>
                <li>
                  <p>配合公司项目制作三维动画场景制作，根据实际数据、影像资料建设虚拟现实三维模型及场景</p>
                </li>
                <li>
                  <p>进行部分Unity3D中的功能扩展和开发</p>
                </li>
                <li>
                  <p>良好的工作热情和态度，有责任心和协作精神</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="job_location">
          {{$t('join.location')}}
        </div>
        <div class="job_return" align="center">
          <div @mouseenter="enter" @mouseleave="leave" :class="isflag==true?'job_return_div1':'job_return_div'"><a
              @click="setroters('/join/index')">返回列表</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import joinpartbanner from "@/components/contentcoms/joincontentcoms/joinpartbanner";
  export default {
    name: "intern",
    components: {joinpartbanner},
      data() {
      return {
        isflag: false
      }
    },
    methods: {
      setroters(src) {
        this.$router.push(src);
      },
      enter: function () {
        this.isflag = true;
      },
      leave: function () {
        this.isflag = false;
      }
    }
  }
</script>

<style scoped>
  .detail_box{
    margin: 0 auto;
    width: 1200px;
    padding-top: 50px;
  }
  .join_title{
    font-size: 24px;
    color: #333333;
    padding-bottom: 20px;
  }
  .company_name{
    font-size: 14px;
    color: #B6B6B6;
    text-align: left;
    padding-bottom: 16px;
    border-bottom: 1px solid #FBFBFB;
  }
  .work_property{
    padding: 22px 0px 22px 20px;
    text-align: left;
    border-bottom: 1px solid #FBFBFB;
  }
  .work_property1{
    font-size: 16px;
    color: #666666;
    padding-right: 110px;
  }
  .work_property2{
    font-size: 16px;
    color: #333333;
  }
  .job_content{
    padding-bottom: 30px;
    border-bottom: 1px solid #FBFBFB;
  }
  .job_describe{
    text-align: left;
    padding: 30px 0px 30px 20px;
  }
  .job_describe_ul{
    padding-top: 18px;
  }
  .job_describe_ul ul {
    color: #2E79BE;
  }
  .job_describe_ul p {
    font-size: 16px;
    color: #666666;
  }
  .job_location{
    text-align: left;
    font-size: 16px;
    color: #333333;
    padding: 20px 0px 20px 20px;
    border-bottom: 1px solid #FBFBFB;
  }
  .job_return{
    margin-top: 10px;
  }

  .job_return a{
    font-size: 14px;
  }
</style>




// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/modeler.vue